var chunkToChildrenMap = {
	"MainRoutes_chunk": [
		"vendors-node_modules_formik_dist_formik_esm_js",
		"vendors-node_modules_react-number-format_dist_react-number-format_es_js",
		"vendors-node_modules_yup_es_index_js",
		"vendors-node_modules_react-datepicker_dist_react-datepicker_min_js",
		"vendors-node_modules_react-datepicker_dist_react-datepicker_css",
		"vendors-node_modules_react-phone-input-2_lib_lib_js-node_modules_react-phone-input-2_lib_mate-b7aa31",
		"vendors-node_modules_use-mediaquery_index_js-node_modules_tanstack_react-table_build_lib_index_mjs",
		"vendors-node_modules_react-slick_lib_index_js",
		"vendors-node_modules_react-input-range_lib_js_index_js-node_modules_react-input-range_lib_css-d4169d",
		"data_image_png_base64_iVBORw0KGgoAAAANSUhEUgAAAZgAAAGACAMAAACnYISRAAADAFBMVEUAAAAxQ5cSO5wAOJP-f90f79",
		"src_components_AuthenticatedApp_components_openApi_common_pagination_NewPagination_js",
		"src_components_AuthenticatedApp_components_modals_sourceaccount_SourceAccountModal_js",
		"src_components_AuthenticatedApp_components_dropdown_LGABusiness_js-src_components_Authenticat-4b3366",
		"src_library_ReactTable_index_js",
		"src_components_AuthenticatedApp_layout_FormLayout_js-src_library_formLayoutMenu_index_js-src_-acb3a6",
		"src_components_AuthenticatedApp_components_account_BusinessRegistration_components_library_Icons_js",
		"src_components_AuthenticatedApp_components_dropdown_Industry_js-src_components_AuthenticatedA-a096f6",
		"src_assets_icons_DarkCheck_svg-src_components_AuthenticatedApp_components_modals_BusinessDocs-7a591a",
		"src_assets_img_successCheck_svg-src_components_AuthenticatedApp_components_dropdown_Bank_js-s-3a8a4b",
		"src_components_AuthenticatedApp_routes_ManageBeneficiaries_routes_js",
		"src_assets_img_access_svg-src_assets_img_addUssdIcon_svg-src_assets_img_copy_svg-src_assets_i-a1e420",
		"src_components_AuthenticatedApp_components_NewToBank_BusinessEddForm_NTBBusinessForm_js",
		"src_components_AuthenticatedApp_components_account_BusinessRegistration_components_library_Dr-492faa",
		"src_components_AuthenticatedApp_components_newAccount_common_icons_emptyFilter_svg-src_compon-f3170c",
		"src_components_AuthenticatedApp_components_newAccount_common_icons_approver_svg-src_component-81fef5",
		"src_assets_icons_dropdown-caret-active_svg-src_assets_img_error-icon_inline_svg-src_component-fcdae5",
		"ACCOUNT_chunk",
		"vendors-node_modules_base64-js_index_js-node_modules_events_events_js-node_modules_inherits_i-39e3e2",
		"vendors-node_modules_qrcode_react_lib_esm_index_js",
		"vendors-node_modules_face-api_js_build_es6_index_js-node_modules_react-webcam_dist_react-webcam_js",
		"vendors-node_modules_react-signature-canvas_build_index_js",
		"src_library_file_fileUpload2_js",
		"src_components_AuthenticatedApp_components_modals_newOnboarding_ProfileExist_js-src_component-38255c",
		"src_assets_img_invite-logo_svg-src_components_AuthenticatedApp_components_onboarding_Freelanc-b084b8",
		"src_components_AuthenticatedApp_components_onboarding_Freelancer_VerifyIdentity_Selfie_js",
		"Onboarding_chunk",
		"NTBBusinessForm_chunk",
		"AddressVerificationV2_chunk",
		"src_components_AuthenticatedApp_components_modals_limits_LimitExceededWrap_js",
		"src_components_AuthenticatedApp_components_modals_payments_BillersErrorModal_js-src_component-7e4175",
		"PAYMENTS_chunk",
		"BENEFICIARIES_chunk",
		"CARDS_chunk",
		"INVOICING_chunk"
	],
	"PAYMENTS_chunk": [
		"vendors-node_modules_use-mediaquery_index_js-node_modules_tanstack_react-table_build_lib_index_mjs",
		"vendors-node_modules_xlsx_xlsx_mjs",
		"src_components_AuthenticatedApp_components_modals_accounts_limits_ConfirmOTP_js-src_component-ab8d56",
		"src_library_file_fileUpload2_js",
		"src_library_ReactTable_index_js",
		"BulkPaymentRoutes_chunk",
		"src_components_AuthenticatedApp_components_payroll_common_common_styles_js",
		"src_components_AuthenticatedApp_components_payments_paymentRequest_components_EmptyState_js-s-d4f7d2",
		"src_components_AuthenticatedApp_components_payments_paymentRequest_common_icons_bulkDetailsIc-c55e4d",
		"PaymentRequestsApproverView_chunk",
		"SignatoryPaymentRequestsList_chunk",
		"src_assets_img_transfers-category_svg-src_components_AuthenticatedApp_components_modals_payme-937ed6",
		"PayBill_chunk",
		"BuyAirtime_chunk",
		"SENDMONE_chunk"
	],
	"CARDS_chunk": [
		"vendors-node_modules_formik_dist_formik_esm_js",
		"vendors-node_modules_yup_es_index_js",
		"src_components_AuthenticatedApp_components_dropdown_LGABusiness_js-src_components_Authenticat-4b3366",
		"src_assets_img_card-verve-ngn_svg-src_assets_img_card-visa-ngn_svg-src_components_Authenticat-e601f5",
		"CardRequest_chunk",
		"src_assets_img_card-illustration_svg",
		"src_assets_img_cardOrderProcessing-verve_svg-src_assets_img_cardOrderProcessing_svg-src_asset-bfae4f",
		"CardHome_chunk",
		"CardActivate_chunk",
		"CardTrack_chunk",
		"CardPin_chunk",
		"CardManage_chunk"
	],
	"INVOICING_chunk": [
		"vendors-node_modules_formik_dist_formik_esm_js",
		"vendors-node_modules_react-number-format_dist_react-number-format_es_js",
		"vendors-node_modules_yup_es_index_js",
		"vendors-node_modules_react-phone-input-2_lib_lib_js-node_modules_react-phone-input-2_lib_mate-b7aa31",
		"data_image_png_base64_iVBORw0KGgoAAAANSUhEUgAAAZgAAAGACAMAAACnYISRAAADAFBMVEUAAAAxQ5cSO5wAOJP-f90f79",
		"src_components_AuthenticatedApp_components_payments_paymentRequest_components_EmptyState_js-s-d4f7d2",
		"src_assets_img_profile-picture-invoice-customer-lg_svg-src_redux_actions_invoiceCustomers_act-c82f26",
		"src_components_AuthenticatedApp_components_invoicing_common_icons_addIcon_svg-src_components_-8e578e",
		"src_components_AuthenticatedApp_components_modals_invoicing_customers_AddCustomer_js",
		"src_components_AuthenticatedApp_components_invoicing_previewInvoice_modal_Sending_js",
		"src_components_AuthenticatedApp_components_invoicing_inventory-v2_api_FetchInventory_js-src_c-fab77a",
		"src_components_AuthenticatedApp_components_invoicing_common_api_useFetchCustomers_js-src_comp-f25df2",
		"CreateEstimate_chunk",
		"ConvertToInvoiceSummaryPage_chunk",
		"vendors-node_modules_react-datepicker_dist_react-datepicker_min_js",
		"vendors-node_modules_react-datepicker_dist_react-datepicker_css",
		"EditInvoice_chunk",
		"src_components_AuthenticatedApp_components_invoicing_invoiceSummary_icon_downIcon_svg-src_com-758b91",
		"src_components_AuthenticatedApp_components_invoicing_previewInvoice_customerdetails_index_js--dd39ef",
		"PreviewEstimate_chunk",
		"PreviewInvoice_chunk",
		"src_components_AuthenticatedApp_components_invoicing_common_api_useFetchCustomers_js-src_comp-504a1e",
		"EstimateSummary_chunk",
		"Summary_chunk",
		"AddItem_chunk",
		"SuccessfulInvoice_chunk",
		"ViewEstimate_chunk",
		"InvoicingHome_chunk"
	],
	"src_components_AuthenticatedApp_routes_BusinessRegistration_routes_js": [
		"vendors-node_modules_formik_dist_formik_esm_js",
		"vendors-node_modules_react-number-format_dist_react-number-format_es_js",
		"vendors-node_modules_yup_es_index_js",
		"vendors-node_modules_react-datepicker_dist_react-datepicker_min_js",
		"vendors-node_modules_react-datepicker_dist_react-datepicker_css",
		"src_components_AuthenticatedApp_components_modals_sourceaccount_SourceAccountModal_js",
		"src_components_AuthenticatedApp_components_payments_paymentRequest_common_icons_rightIcon_svg-de5831",
		"src_assets_img_loaderGrey_svg-src_assets_img_searchIconNew_svg-src_assets_img_warningIconSmal-92cb30",
		"BusinessName_chunk",
		"CompanyRegistration_chunk",
		"src_components_AuthenticatedApp_components_payments_paymentRequest_components_EmptyState_js-s-d4f7d2",
		"BusinessRegistration_chunk"
	],
	"InvoicingHome_chunk": [
		"vendors-node_modules_formik_dist_formik_esm_js",
		"vendors-node_modules_yup_es_index_js",
		"vendors-node_modules_react-phone-input-2_lib_lib_js-node_modules_react-phone-input-2_lib_mate-b7aa31",
		"vendors-node_modules_use-mediaquery_index_js-node_modules_tanstack_react-table_build_lib_index_mjs",
		"data_image_png_base64_iVBORw0KGgoAAAANSUhEUgAAAZgAAAGACAMAAACnYISRAAADAFBMVEUAAAAxQ5cSO5wAOJP-f90f79",
		"src_assets_img_profile-picture-invoice-customer-lg_svg-src_redux_actions_invoiceCustomers_act-c82f26",
		"src_library_ReactTable_index_js",
		"src_components_AuthenticatedApp_components_modals_invoicing_customers_AddCustomer_js",
		"src_assets_img_warning-delete_svg-src_components_AuthenticatedApp_components_emptyStates_Empt-b5c19e",
		"Customers_chunk",
		"vendors-node_modules_react-number-format_dist_react-number-format_es_js",
		"vendors-node_modules_lodash_mapValues_js-node_modules_lodash_upperFirst_js-node_modules_react-b233e5",
		"src_components_AuthenticatedApp_components_payments_paymentRequest_components_EmptyState_js-s-d4f7d2",
		"src_components_AuthenticatedApp_components_invoicing_common_icons_addIcon_svg-src_components_-8e578e",
		"src_components_AuthenticatedApp_components_payments_paymentRequest_common_icons_rightIcon_svg-a2953f",
		"src_assets_img_march_failedTransactions_svg-src_components_AuthenticatedApp_components_skelet-20ee25",
		"src_components_AuthenticatedApp_components_invoicing_settings_index_js",
		"Estimate_chunk",
		"Invoice_chunk",
		"src_components_AuthenticatedApp_components_invoicing_inventory-v2_api_FetchInventory_js-src_c-fab77a",
		"Inventory_chunk",
		"DraftInvoice_chunk"
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));